<template>
  <div class="w-[100%] h-screen">
    <iframe
      v-if="selectedNews"
      :src="selectedNews.pdf"
      width="100%"
      height="100%"
      style="border: none"
    >
    </iframe>

    <p v-else>PDF ачааллаж байна...</p>
  </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();

    const id = Number(route.params.id);

    const monthNews = computed(() => store.state.admin.monthNews);

    const selectedNews = computed(() =>
      monthNews.value.find((n) => n.id === id)
    );

    onMounted(async () => {
      await store.dispatch("admin/fetchMonthNewsPdf");
    });

    return { selectedNews };
  },
};
</script>
